import React, { useEffect, useState } from 'react';

//MUI
import {
    Box, Card, CardActionArea, CardContent, Chip, Container,
    Grid as MUIGrid, Typography, IconButton, Snackbar
} from '@mui/material';
import InventoryIcon from '@mui/icons-material/Inventory';
import CategoryIcon from '@mui/icons-material/Category';
import BookIcon from '@mui/icons-material/Book';
import DashboardIcon from '@mui/icons-material/Dashboard';
import ReceiptIcon from '@mui/icons-material/Receipt';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import CorporateFareIcon from '@mui/icons-material/CorporateFare';
import StorefrontIcon from '@mui/icons-material/Storefront';
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import CloseIcon from '@mui/icons-material/Close';

//redux
import { useSelector } from 'react-redux';

//components
import CalendarWidget from './CalendarWidget';
import HourWidget from './HourWidget';
import WeatherWidget from './WeatherWidget/WeatherWidget';

//router dom
import { useNavigate } from 'react-router-dom';

import { getModuleSummary } from '../../../actions/admin/dashboard';

// Import Swiper styles
// import { Swiper, SwiperSlide } from 'swiper/react';
// import { Grid, Pagination } from "swiper";
// import 'swiper/css';
// import "swiper/css/grid";
// import "swiper/css/pagination";

const AdminIndex = () => {
    const hour = new Date().getHours();
    const isDay = hour >= 6 && hour < 19;
    const navigate = useNavigate();

    const { loggedUser: { username } } = useSelector(state => state.user);
    const { shipping: { methods: { full_list } } } = useSelector(state => state.shop);

    const [moduleData, setModuleData] = useState({
        products: 0, categories: 0, blog: 0, orders: '',
        coupons: 0, admins: 0, brands: 0, branches: 0
    });
    const {
        products, categories, blog, orders, coupons, admins, brands, branches
    } = moduleData;

    const [snackbarData, setSnackbarData] = useState({
        open: false, message: ''
    });
    const { open, message } = snackbarData;

    useEffect(() => {
        getModuleSummary(setModuleData, setSnackbarData);
    }, []);

    const getText = (value, singular, plural) => {
        const label = value === 1 ? singular : plural;
        return `${value > 99 ? "99+" : value} ${label}`;
    };

    const data = [
        {
            name: 'Productos',
            description: 'Consulta y administra el catálogo de productos de la tienda',
            icon: <InventoryIcon sx={{ color: '#1D4ED8' }} />,
            mainColor: '#CFE4FF',
            secondColor: '#1D4ED8',
            chipValue: getText(products, 'producto', 'productos'),
            link: 'productos'
        },
        {
            name: 'Categorías',
            description: 'Categorías y subcategorías de productos',
            icon: <CategoryIcon sx={{ color: '#047857' }} />,
            mainColor: '#C8F2DE',
            secondColor: '#047857',
            chipValue: getText(categories, 'categoría', 'categorías'),
            link: 'categorias-productos'
        },
        {
            name: 'Blog',
            description: 'Publica y administra el contenido informativo del blog',
            icon: <BookIcon sx={{ color: '#BE185D' }} />,
            mainColor: '#FFE4EC',
            secondColor: '#BE185D',
            chipValue: getText(blog, 'entrada', 'entradas'),
            link: 'blog'
        },
        {
            name: 'Dashboard',
            description: 'Consulta indicadores y métricas generales de la tienda',
            icon: <DashboardIcon sx={{ color: '#C2410C' }} />,
            mainColor: '#FFE9DC',
            secondColor: '#C2410C',
            chipValue: `Estado general`,
            link: 'dashboard'
        },
        {
            name: 'Pedidos',
            description: 'Consulta y gestiona los pedidos realizados en la tienda',
            icon: <ReceiptIcon sx={{ color: '#6D28D9' }} />,
            mainColor: '#EDE9FE',
            secondColor: '#6D28D9',
            chipValue: orders,
            link: 'pedidos'
        },
        {
            name: 'Métodos de envío',
            description: 'Configura las opciones y tarifas disponibles para los envíos',
            icon: <LocalShippingIcon sx={{ color: '#0E7490' }} />,
            mainColor: '#DDFBFF',
            secondColor: '#0E7490',
            chipValue: `${full_list.length} ${
                full_list.length === 1 ? 'método' : 'métodos'
            }`,
            link: 'metodos-envio'
        },
        {
            name: 'Cupones',
            description: 'Crea y administra cupones de descuento para la tienda',
            icon: <LocalOfferIcon sx={{ color: '#B45309' }} />,
            mainColor: '#FFF8DB',
            secondColor: '#B45309',
            chipValue: getText(coupons, 'cupón', 'cupones'),
            link: 'cupones'
        },
        {
            name: 'Administradores del sitio',
            description: 'Gestiona administradores y sus permisos de acceso al panel',
            icon: <AdminPanelSettingsIcon sx={{ color: '#334155' }} />,
            mainColor: '#E8EEF7',
            secondColor: '#334155',
            chipValue: getText(admins, 'administrador', 'administradores'),
            link: 'admins'
        },
        {
            name: 'Marcas',
            description: 'Marcas y líneas de producto',
            icon: <CorporateFareIcon sx={{ color: '#A21CAF' }} />,
            mainColor: '#FFE3F6',
            secondColor: '#A21CAF',
            chipValue: getText(brands, 'marca', 'marcas'),
            link: 'marcas-productos'
        },
        {
            name: 'Sucursales',
            description: 'Tiendas físicas de Nefrópolis',
            icon: <StorefrontIcon sx={{ color: '#1D4ED8' }} />,
            mainColor: '#CFE4FF',
            secondColor: '#1D4ED8',
            chipValue: getText(branches, 'sucursal', 'sucursales'),
            link: 'sucursales'
        },
    ];
    
    // cerrar snackbar
    const handleClose = () => {
        setSnackbarData(e => ({ ...e, open: false }));
    };

    const action = (
        <React.Fragment>
            <IconButton
                size="small"
                aria-label="close"
                color="inherit"
                onClick={handleClose}>
                <CloseIcon fontSize="small" />
            </IconButton>
        </React.Fragment>
    );

    return (
        <Container maxWidth='xxl' sx={{ mt: 12, mb: 5 }}>
            <Box sx={{ mb: 2 }}>
                <Typography variant='h5' sx={{ fontWeight: '600' }}>
                    {isDay ? 'Buenas tardes' : 'Buenas noches'} {username}
                </Typography>
                <Typography variant='body2'>
                    <span style={{ fontWeight: '800' }}>Acceso rápido a secciones:</span> navega directamente a cualquier módulo del panel
                </Typography>
            </Box>
            <MUIGrid container spacing={4}>
                {
                    data.map((item, index) => (
                        <MUIGrid item xxl={3} xl={3} lg={4} md={6} sm={6} xs={12} key={index}>
                            <Card
                                sx={{
                                    boxShadow: '0 2px 4px 2px rgb(0 0 0 / 20%)', borderRadius: '6px', border: '2px solid transparent',
                                    '&:hover': {
                                        border: `2px solid ${item.secondColor}`,
                                        boxShadow: '0 4px 12px rgb(0 0 0 / 15%)'
                                    },
                                    '&:hover .arrow-btn': {
                                        backgroundColor: item.secondColor,
                                        color: '#fff'
                                    }
                                }}
                            >
                                <CardActionArea onClick={() => { navigate(`/nefro-admin/${item.link}`) }}>
                                    <CardContent>
                                        <Box sx={{ display: 'flex', justifyContent: 'space-between', gap: '12px', mb: 1.5 }}>
                                            <Box sx={{ p: 1.3, bgcolor: item.mainColor, borderRadius: '10px' }}>
                                                {item.icon}
                                            </Box>
                                            <Box>
                                                <button className="arrow-btn" style={{ border: 'none', borderRadius: '10px' }}>
                                                    <ArrowRightAltIcon />
                                                </button>
                                            </Box>
                                        </Box>
                                        <Typography variant='body1' sx={{ fontWeight: '700' }}>
                                            {item.name}
                                        </Typography>
                                        <Typography variant='body2' paragraph>
                                            {item.description}.
                                        </Typography>
                                        <Chip label={item.chipValue} size='small' sx={{ bgcolor: item.mainColor, color: item.secondColor, fontWeight: '600', cursor: 'pointer' }} />
                                    </CardContent>
                                </CardActionArea>
                            </Card>
                        </MUIGrid>
                    ))
                }
            </MUIGrid>

            {/* <Swiper style={{marginTop: 20}}
                slidesPerView={4}
                grid={{
                    rows: 2,
                    fill: "row",
                }}
                spaceBetween={30}
                pagination={{
                    clickable: true,
                }}
                modules={[Grid, Pagination]}
                className="mySwiper"
            >
                {
                    data.map((item) => (
                        <SwiperSlide key={item.id}>
                            <Card
                                sx={{
                                    boxShadow: '0 2px 4px 2px rgb(0 0 0 / 20%)', borderRadius: '6px', border: '2px solid transparent',
                                    '&:hover': {
                                        border: `2px solid ${item.secondColor}`,
                                        boxShadow: '0 4px 12px rgb(0 0 0 / 15%)'
                                    },
                                    '&:hover .arrow-btn': {
                                        backgroundColor: item.secondColor,
                                        color: '#fff'
                                    }
                                }}
                            >
                                <CardActionArea onClick={() => { navigate(`/nefro-admin/${item.link}`) }}>
                                    <CardContent>
                                        <Box sx={{ display: 'flex', justifyContent: 'space-between', gap: '12px', mb: 1.5 }}>
                                            <Box sx={{ p: 1.3, bgcolor: item.mainColor, borderRadius: '10px' }}>
                                                {item.icon}
                                            </Box>
                                            <Box>
                                                <button className="arrow-btn" style={{ border: 'none', borderRadius: '10px' }}>
                                                    <ArrowRightAltIcon />
                                                </button>
                                            </Box>
                                        </Box>
                                        <Typography variant='body1' sx={{ fontWeight: '700' }}>
                                            {item.name}
                                        </Typography>
                                        <Typography variant='body2' paragraph>
                                            {item.description}
                                        </Typography>
                                        <Chip label={item.chipValue} size='small' sx={{ bgcolor: item.mainColor, color: item.secondColor, fontWeight: '600', cursor: 'pointer' }} />
                                    </CardContent>
                                </CardActionArea>
                            </Card>
                        </SwiperSlide>
                    ))
                }
            </Swiper> */}

            <Box sx={{ mt: 4, mb: 1.5 }}>
                <Typography variant='h6' sx={{ fontWeight: '500' }}>Aquí tienes un resumen de lo que está pasando hoy</Typography>
            </Box>

            <MUIGrid container spacing={4}>
                <MUIGrid item xxl={3.5} xl={3.5} lg={6} md={6} sm={12} xs={12} sx={{ display: 'flex' }}>
                    <Box sx={{ boxShadow: '0 2px 4px 2px rgb(0 0 0 / 20%)', borderRadius: 3, border: "1px solid #e8ecf2", p: 2.5, width: '100%' }}>
                        <CalendarWidget />
                    </Box>
                </MUIGrid>

                <MUIGrid item xxl={5} xl={5} lg={6} md={6} sm={12} xs={12} sx={{ display: 'flex' }}>
                    <Box sx={{ boxShadow: '0 2px 4px 2px rgb(0 0 0 / 20%)', borderRadius: 3, border: "1px solid #e8ecf2", p: 2.5, width: '100%' }}>
                        <WeatherWidget isDay={isDay} />
                    </Box>
                </MUIGrid>

                <MUIGrid item xxl={3.5} xl={3.5} lg={6} md={6} sm={12} xs={12} sx={{ display: 'flex' }}>
                    <Box sx={{ boxShadow: '0 2px 4px 2px rgb(0 0 0 / 20%)', borderRadius: 3, border: "1px solid #e8ecf2", p: 2.5, width: '100%' }}>
                        <HourWidget />
                    </Box>
                </MUIGrid>
            </MUIGrid>

            <Snackbar
                open={open}
                autoHideDuration={6000}
                onClose={handleClose}
                message={message}
                action={action}
            />
        </Container>
    );

}

export default AdminIndex
